import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TransactionTypeChar } from '@tassat/common-definitions';
import { TransactionHistoryRecord } from '@tassat/fred-extended-definitions';
import React from 'react';

import history from 'Lib/browserHistory';

type LinkCellRendererProps = {
    data: TransactionHistoryRecord;
    state: Record<string, any>;
};

const muiStyles = makeStyles({
    root: {
        height: '100%',
        whiteSpace: 'normal' as const
    },
    text: {
        cursor: 'pointer' as const,
        textDecoration: 'underline' as const
    }
});

const TransactionAccountLinkCellRenderer = (props: LinkCellRendererProps) => {
    const {
        data,
        state = {}
    } = props;

    const classes = muiStyles(props);

    const sender = [
        TransactionTypeChar.order as string,
        TransactionTypeChar.send as string,
        TransactionTypeChar.deposit as string
    ].includes(data.type);

    const handleLink = () => {
        history.push(`/accounts/${sender ? data.SenderAccountId : data.RecipientAccountId}`, state);
    };

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            <span
                className={classes.text}
                onClick={handleLink}
            >
                {sender ? data.SenderAccountName : data.RecipientAccountName}
            </span>
        </Grid>
    );
};

export default TransactionAccountLinkCellRenderer;